module.exports = __webpack_public_path__ + "img/33-800x800.030ea3d0.jpg";